import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import AlertsGroup from "client_config/AlertsGroup";
import ManageSubsByClient from "alert_subscriptions/ManageSubsByClient";
import OnboardingAlertsGroup from "onboarding/AlertsGroup";

const addUser = (email, sectionName, sectionId) => {
  let returnedData = "";
  if (email && email != "" && sectionId && sectionId != "") {
    $.ajax({
      type: "POST",
      url: "/datapulse/alerts/subscribe-user/",
      async: false,
      data: {
        email: email,
        section_name: sectionName,
        section_id: sectionId,
      },
      success: (data) => {
        returnedData = data;
      },
    });
  }
  return returnedData;
};

const removeUser = (email, sectionName, sectionId) => {
  let removalSuccessful = false;
  if (email && email != "" && sectionId && sectionId != "") {
    $.ajax({
      type: "POST",
      url: "/datapulse/alerts/unsubscribe-user/",
      async: false,
      data: {
        email: email,
        section_name: sectionName,
        section_id: sectionId,
      },
      success: () => {
        removalSuccessful = true;
      },
    });
  }
  return removalSuccessful;
};

export default function Alerts(props) {
  const platforms = [
    {
      platformName: "Google Analytics",
      alerts: [
        {
          name: "google_analytics_seo_traffic_fluctuation_detector",
          title: "Traffic Fluctuation Detector",
          desc: "Checks if the number of organic sessions rises above or below 20% compared to the last 3 instances of yesterday.",
          options: [
            { name: "min_threshold", title: "Min Threshold", placeholder: "Default 80%" },
            { name: "max_threshold", title: "Max Threshold", placeholder: "Default 120%" },
          ],
        },
      ],
    },
  ];
  return (
    <Container fluid className="top-div seo-config-tab-content mb-5 p-3" style={{ backgroundColor: "#eeeeee" }}>
      <Row>
        <Col>
          <div className="pt-4 pb-2">
            <p className="green f18 visby-bold">Alerts:</p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="px-md-5 px-3" xl={8}>
          <div className="pb-4 px-lg-3 px-0">
            {platforms.map((platform) => {
              return props.onboarding ? (
                <OnboardingAlertsGroup
                  key={platform.platformName}
                  platform={platform}
                  service="seo"
                  scripts={props.seoScripts}
                  scriptVariables={props.seoScriptsVar}
                  setScripts={props.setSeoScripts}
                  setScriptsVar={props.setSeoScriptsVar}
                  onboarding
                />
              ) : (
                <AlertsGroup
                  key={platform.platformName}
                  platform={platform}
                  service="seo"
                  scripts={props.seo_section.scripts}
                  scriptVariables={props.seo_section.script_variables}
                />
              );
            })}
          </div>
        </Col>
        <Col xl={4}>
          <div
            className="subs-by-client pt-4 mb-4 px-3 mx-lg-3 mx-0"
            style={{
              backgroundColor: "#e1e1e1",
              paddingBottom: "150px"
            }}>
            <h5>Subscribed to these alerts:</h5>
            <ManageSubsByClient
              users={props.users}
              addUser={addUser}
              removeUser={removeUser}
              subscribed_users={props.subs.seo_subs}
              section_id={props.subs.seo_section_id}
              section_name="SeoSection"
              client_name={props.company_name}
            />
          </div>
        </Col>
      </Row>
    </Container>
  );
}
